import * as React from "react";
const SvgWidgetOrderArrow = props => <svg xmlns="http://www.w3.org/2000/svg" width={7} height={5} viewBox="0 0 7 5" fill="none" {...props}><path d="M0.355469 3.70703L3.35547 0.707031L6.35547 3.70703" stroke="currentColor" /></svg>;
export default SvgWidgetOrderArrow;